<template>
    <div>
        <Header></Header>
        <div class="aboutUsCon">
            <div class="cover"></div>
            <div class="content">
                <p v-html="item"></p>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../../components/Header_M.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
        item:''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await this.$axios.get("steppyplus", {
      });
      this.item = res.data.about
    },
  }
}
</script>
<style scoped>
.aboutUsCon{
    width: 100%;
    height: fit-content;
    min-height: calc(100vh - 51px);
    background-color: #000;
    color: #fff;
    padding-top: 50px;
}
.aboutUsCon .cover{
    width: inherit;
    height: 300px;
    background: transparent url('../../assets/aboutus.png') center no-repeat;
    background-size: 30%;
}
.aboutUsCon .content{
    width: inherit;
    height: 50%;
    font-size: 12px;
    line-height: 18px;
    color: #fff;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 12% 4%;
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/AboutUs.vue